﻿var $ = require('jquery');

var StickyLogotype = function (customOptions) {

    var defaultOptions = {
        element: null,
        inactiveSession: true,
        actionDelay: 300
    };

    var options = $.extend({}, defaultOptions, customOptions);
    var $logotype = $(options.element);
    $logotype.addClass('visible');
    var $header = $logotype.find('+ .container');
    var $logoHeight = $logotype.outerHeight();
    var $inactiveSession = $(options.inactiveSession);
    var $stickyMenu = $('.sf_colsIn.header-with-placeholder-top.stick-to-page-top');
    var $menuShadow = $stickyMenu.find('+ .stick-to-page-top-and-hide-on-scroll-shadow');
    var $subscribeField = $('.sign-up-popup');
    var $registerForm = $subscribeField.find('.register-form');
    var $thirdMenu = $('.header-with-placeholder-top.stick-to-page-top-and-hide-on-scroll');

    function checkScrollAndUpdateMenu() {
        if ($(window).scrollTop() > $logoHeight) {
            $inactiveSession = false;
            $(window).off('scroll', checkScrollAndUpdateMenu);
            $logotype.removeClass('visible');
            $stickyMenu.add($menuShadow).add($subscribeField).css('position', 'fixed');
            $menuShadow.add($subscribeField).css('top', 0);
            $thirdMenu.css('padding-top', $stickyMenu.height()).removeClass('attached');
            window.scrollBy(0, -100);
            adjustHeaderTopPladeholderHeight();
        }
        else{
            adjustHeaderTopPladeholderHeight();
            $thirdMenu.css('top', 0);
        }
        
    }; 
    if ($inactiveSession) {
        $stickyMenu.add($menuShadow).add($subscribeField).add($thirdMenu).css('position', 'absolute');
        $menuShadow.add($subscribeField).css('top', $logoHeight);
        $(window).on('scroll', checkScrollAndUpdateMenu);
        adjustHeaderTopPladeholderHeight();
        $thirdMenu.css('padding-top', $stickyMenu.height()).addClass('attached');
    }
    $(window).on('resize', function () {
        if (window.innerWidth > 948) {
            $stickyMenu.add($menuShadow).add($subscribeField).add($thirdMenu).css('position', 'fixed');
        }
        else if($inactiveSession) {
            $stickyMenu.add($menuShadow).add($subscribeField).add($thirdMenu).css('position', 'absolute');
        }
        $thirdMenu.css('padding-top', $stickyMenu.height());


    });
};

var adjustHeaderTopPladeholderHeight = function () {

    let heightSum = 0;
    $('.header-with-placeholder-top').each(function () {
        heightSum += $(this).height();
    });
    $('.header-with-placeholder-top-placeholder').height(heightSum);
};

module.exports = StickyLogotype;


